import { watchStartMeeting } from "./startMeeting";
import { watchMeetingHeartbeat } from "./heartbeat";
import { watchInitializeMultiPartyEvent } from "./initializeMultiPartyEvent";

export default [
  watchStartMeeting(),
  watchMeetingHeartbeat(),
  watchInitializeMultiPartyEvent()
];
